(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-banner-strip"] && !Shopify.designMode) return;
  try {
    
  class MSBannerStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ms-banner-strip__track');
      this.items = Array.from(this.querySelectorAll('.ms-banner-strip__item'));
      if (!this.track || this.items.length < 2) return;
      this.index = 0;
      this.buildDots();
      const prev = this.querySelector('.ms-banner-strip__arrow--prev');
      const next = this.querySelector('.ms-banner-strip__arrow--next');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._scrollT);
        this._scrollT = setTimeout(() => this.syncFromScroll(), 80);
      }, { passive: true });
      const secs = parseInt(this.dataset.autoplay || '0', 10);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (secs > 0 && !reduced) {
        this.start(secs);
        ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
        this.addEventListener('mouseleave', () => this.start(secs));
      }
    }
    disconnectedCallback() { this.stop(); }
    start(secs) { this.stop(); this._timer = setInterval(() => this.go(this.index + 1), secs * 1000); }
    stop() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
    go(i) {
      this.index = (i + this.items.length) % this.items.length;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
      this.paintDots();
    }
    syncFromScroll() {
      this.index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      this.paintDots();
    }
    buildDots() {
      const wrap = this.querySelector('.ms-banner-strip__dots');
      if (!wrap) return;
      this.items.forEach((_, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'ms-banner-strip__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Franja ' + (i + 1));
        d.addEventListener('click', () => this.go(i));
        wrap.appendChild(d);
      });
      this.paintDots();
    }
    paintDots() {
      this.querySelectorAll('.ms-banner-strip__dot').forEach((d, i) => {
        d.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });
    }
  }
  if (!customElements.get('ms-banner-strip')) customElements.define('ms-banner-strip', MSBannerStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-hero-v2-split"] && !Shopify.designMode) return;
  try {
    
  /* Un solo listener delegado: la seccion puede aparecer varias veces en la pagina
     y asi no se monta un handler por instancia. Al dar play se prenden los
     controles nativos (ya no molestan: la persona los pidio) y se quita el mute. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ms-hv2-play]');
    if (!button) return;

    var video = document.getElementById(button.getAttribute('data-ms-hv2-play'));
    if (!video) return;

    video.controls = true;
    video.muted = false;

    var played = video.play();
    if (played && typeof played.catch === 'function') {
      /* Si el navegador rechaza el sonido, al menos que el video corra. */
      played.catch(function () {
        video.muted = true;
        video.play();
      });
    }

    button.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart {
    constructor() {
      this.element = document.querySelector('[data-sticky-add-to-cart]');
      this.mainAddToCartButton = this.findMainAddToCartButton();
      this.destroyed = false;
      this.intervals = [];
      this.observers = [];
      
      if (!this.element) return;

      this.init();
    }

    destroy() {
      this.destroyed = true;
      this.stopBuyBoxSettle();
      clearTimeout(this.mirrorTimeout);
      this.intervals.forEach(id => clearInterval(id));
      this.intervals = [];
      this.observers.forEach(obs => obs.disconnect());
      this.observers = [];
      if (this.quantityBreaksObserver) {
        this.quantityBreaksObserver.disconnect();
        this.quantityBreaksObserver = null;
      }
      if (this.animationObserver) {
        this.animationObserver.disconnect();
        this.animationObserver = null;
      }
      if (this.quantityBreaksClickHandler) {
        document.removeEventListener('click', this.quantityBreaksClickHandler);
      }
    }

    findMainAddToCartButton() {
      // Look for the main add to cart button in various possible locations
      const selectors = [
        // El buy box propio (ms-oferta) va PRIMERO: cuando su CTA existe, la
        // barra debe esconderse mientras esta en pantalla. Sin esto el codigo
        // no encontraba ningun boton, caia al respaldo de abajo y dejaba la
        // barra visible DESDE ARRIBA de la pagina.
        '[data-ms-cta]',
        // MS · 22-sep-2026 (cosechado de Malara) — el CTA de `ms-promo-opciones`.
        // Es un <a class="ms-po__cta">, no un <button>, y cuando el bloque esta
        // prendido es el UNICO boton de compra visible del buy box.
        '.ms-po__cta',
        '.buy-buttons-block .add-to-cart-button',
        '.product-form-buttons .add-to-cart-button',
        '.product-details .add-to-cart-button',
        '[data-testid="product-information-details"] .add-to-cart-button',
        'product-form-component .add-to-cart-button',
        'form[data-type="add-to-cart-form"] button[type="submit"]',
        '.product-form button[type="submit"]',
        '.add-to-cart-button',
        'button[name="add"]'
      ];
      
      // MS · 22-sep-2026 (cosechado de Malara) — un candidato sin caja no cuenta.
      // Un rectangulo de area cero en y=0 cae dentro de la pantalla, asi que
      // `isMainAddToCartVisible()` decia «el boton esta a la vista» SIEMPRE y la
      // barra fija no salia nunca. Nos quedamos con el primer candidato que de
      // verdad ocupe espacio; si ninguno lo ocupa todavia (DOM sin maquetar),
      // devolvemos el primero como antes y el re-escaneo del scroll lo corrige.
      let respaldo = null;

      for (const selector of selectors) {
        const botones = document.querySelectorAll(selector);
        for (const button of botones) {
          if (respaldo === null) respaldo = button;
          if (this.tieneCaja(button)) return button;
        }
      }

      return respaldo;
    }

    // Un elemento cuenta como boton real solo si ocupa area en pantalla.
    tieneCaja(el) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    init() {
      this.setupScrollListener();
      this.setupPriceUpdates();
      this.setupPriceObserver();
      this.setupVariantsDisplay();
      this.setupVisibilityClasses();
      this.setupThemeEditorUpdates();
      this.setupVariantLinkClick();
      this.setupStickyButtonClick();
      this.setupBuyBoxMirror();
      this.setupButtonStateSync();
      this.setupQuantityBreaksListener();
      this.setupQuantityUpdates();
      
      // Initialize compact class
      this.updateCompactClass();
      
      // Get initial quantity after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.currentQuantity = this.getInitialQuantity();
        this.updateButtonText();
      }, 100);
      
      // Also update on DOMContentLoaded if not already loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.currentQuantity = this.getInitialQuantity();
          this.updateButtonText();
        });
      }
      
      // Initialize image with current variant
      this.updateImage();
      
      // Check main button visibility immediately
      this.updateVisibility();
      
      // Check for quantity breaks price on initial load
      setTimeout(() => this.updatePriceFromQuantityBreaks(), 100);
    }


    isMainAddToCartVisible() {
      if (!this.mainAddToCartButton) return false;
      
      const rect = this.mainAddToCartButton.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // MS · 22-sep-2026 — sin area no esta a la vista (ver findMainAddToCartButton).
      if (rect.width <= 0 || rect.height <= 0) return false;
      
      // Check if the main button is visible in the viewport
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= windowHeight &&
        rect.right <= window.innerWidth
      );
    }

    setupPriceUpdates() {
      // Listen for variant selected events (from variant picker)
      document.addEventListener('variant:selected', (event) => {
        this.updatePriceFromVariantId(event.detail.resource.id);
        this.updateImage();
      });

      // Listen for variant update events - this is the main event with full variant data
      document.addEventListener('variant:update', (event) => {
        // The variant data is in event.detail.resource
        const variant = event.detail.resource;
        if (variant) {
          this.updatePrice(variant);
          this.updateImageFromVariant(variant);
        } else {
          this.copyPriceFromMain();
          this.updateImage();
        }
      });

      // The main variant:update event should handle most cases
      // Keep a simple fallback for any missed events
      document.addEventListener('change', (event) => {
        if (event.target.name === 'id' && event.target.closest('form[data-type="add-to-cart-form"]')) {
          this.updatePriceFromVariantId(event.target.value);
          this.updateImage();
        }
      });
    }

    setupQuantityBreaksListener() {
      // Listen for clicks on quantity break cards
      this.quantityBreaksClickHandler = (event) => {
        const clickedCard = event.target.closest('.quantity-breaks__card');
        if (clickedCard) {
          setTimeout(() => this.updatePriceFromQuantityBreaks(), 50);
        }
      };
      document.addEventListener('click', this.quantityBreaksClickHandler);
      
      // Watch for active class changes on quantity break cards
      const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
      if (quantityBreaksComponent) {
        this.quantityBreaksObserver = new MutationObserver(() => {
          if (this.destroyed) return;
          this.updatePriceFromQuantityBreaks();
        });
        
        this.quantityBreaksObserver.observe(quantityBreaksComponent, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    updatePriceFromQuantityBreaks() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      // Check if price override is enabled in sticky-add-to-cart
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (!stickyOverrideEnabled) return;

      const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
      if (!quantityBreaksComponent) return;

      const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
      if (!activeCard) return;

      const quantityPriceElement = activeCard.querySelector('.quantity-breaks__price');
      const quantityComparePriceElement = activeCard.querySelector('.quantity-breaks__original-price');
      
      if (!quantityPriceElement) return;

      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // Get show_sale_price_first setting
      const showSalePriceFirst = priceElement.dataset.showSalePriceFirst === 'true';

      // Update only the price values, preserving price-split markup (strip per-unit label clone)
      const priceContainer = priceElement.querySelector('[ref="priceContainer"]') || priceElement;
      const currentPriceSpan = priceContainer.querySelector('.price') || priceElement.querySelector('.price');
      
      // Find ALL compare price elements to handle duplicates
      // Check both in priceContainer and priceElement to catch all instances
      const containerComparePrices = priceContainer.querySelectorAll('.compare-at-price');
      const elementComparePrices = priceElement.querySelectorAll('.compare-at-price');
      const allComparePriceSpans = [];
      
      // Collect all unique compare price elements
      containerComparePrices.forEach(span => allComparePriceSpans.push(span));
      elementComparePrices.forEach(span => {
        if (!priceContainer.contains(span) && !allComparePriceSpans.includes(span)) {
          allComparePriceSpans.push(span);
        }
      });
      
      if (currentPriceSpan) {
        const priceClone = quantityPriceElement.cloneNode(true);
        priceClone.querySelectorAll('.quantity-breaks__per-unit-text').forEach((el) => el.remove());
        currentPriceSpan.innerHTML = priceClone.innerHTML.trim();
        if (!quantityComparePriceElement) {
          currentPriceSpan.style.marginLeft = '';
        }
      }

      if (quantityComparePriceElement) {
        allComparePriceSpans.forEach(compareSpan => {
          compareSpan.remove();
        });

        const comparePriceSpan = document.createElement('span');
        comparePriceSpan.className = 'compare-at-price price--compare';
        const compareClone = quantityComparePriceElement.cloneNode(true);
        compareClone.querySelectorAll('.quantity-breaks__per-unit-text').forEach((el) => el.remove());
        comparePriceSpan.innerHTML = compareClone.innerHTML.trim();
        
        // Set margin based on show_sale_price_first setting
        if (showSalePriceFirst) {
          comparePriceSpan.style.marginLeft = 'var(--margin-xs, 0.5rem)';
        } else {
          comparePriceSpan.style.marginLeft = '';
          if (currentPriceSpan) {
            currentPriceSpan.style.marginLeft = 'var(--margin-xs, 0.5rem)';
          }
        }
        
        // Respect show_sale_price_first setting for positioning
        if (currentPriceSpan) {
          if (showSalePriceFirst) {
            // Sale price first: price comes before compare price
            currentPriceSpan.insertAdjacentElement('afterend', comparePriceSpan);
          } else {
            // Compare price first: compare price comes before price
            currentPriceSpan.insertAdjacentElement('beforebegin', comparePriceSpan);
          }
        } else {
          priceContainer.appendChild(comparePriceSpan);
        }
      } else {
        // If compare price doesn't exist in quantity breaks but exists in sticky price, remove all of them
        allComparePriceSpans.forEach(compareSpan => {
          compareSpan.remove();
        });
        
        // Reset margin on price span when compare price is removed
        if (currentPriceSpan) {
          currentPriceSpan.style.marginLeft = '';
        }
      }
    }

    // Removed complex observers since we're using the main event system


    setupVariantsDisplay() {
      // Initialize variants display
      this.updateVariantsDisplay();
      
      // Listen for variant changes to update variants display
      document.addEventListener('variant:update', (event) => {
        this.updateVariantsDisplay();
      });
    }

    setupVariantLinkClick() {
      // Use event delegation to handle clicks on variant links (and descendants like SVG icon)
      this.element.addEventListener('click', (event) => {
        if (event.target.matches('[data-scroll-to-variants]') || event.target.closest('[data-scroll-to-variants]')) {
          event.preventDefault();
          this.scrollToVariantSelector();
        }
      });
    }

    setupStickyButtonClick() {
      // Handle clicks on the sticky add to cart button
      this.element.addEventListener('click', (event) => {
        if (event.target.matches('[data-sticky-add-to-cart-button]') ||
            event.target.closest('[data-sticky-add-to-cart-button]')) {
          event.preventDefault();
          // Modo "subir a la caja de compra": ver el comentario del Liquid.
          if (this.element.dataset.buttonAction === 'scroll') {
            // Modo espejo: el rotulo dice a donde va el toque. Con la caja
            // fuera de pantalla el toque VIAJA; con la caja enfrente, AGREGA.
            // Nunca hay un toque muerto ni un rotulo que prometa de mas.
            if (this.buyBoxMirror) {
              if (this.isBuyBoxInView(this.buyBoxMirror)) this.addFromBuyBoxMirror();
              else this.scrollToBuyBox();
              return;
            }
            // Sin espejo (otra caja de compra): si ya esta en pantalla el clic
            // agrega; si no, sube.
            const box = this.findBuyBox();
            if (box && this.isBuyBoxInView(box)) {
              this.triggerBuyBoxAddToCart(box);
              return;
            }
            this.scrollToBuyBox();
            return;
          }
          this.triggerMainAddToCart();
        }
      });
    }

    /**
     * Sube a la caja de compra en vez de agregar. Se usa cuando el precio
     * depende de una eleccion previa (paquetes 1/3/6, suscripcion): agregar a
     * ciegas meteria al carrito la opcion que estuviera marcada.
     * El selector es editable; la lista de abajo son respaldos por si el tema
     * de destino nombra su caja de otra forma.
     */
    scrollToBuyBox() {
      const target = this.findBuyBox();
      if (!target) return;

      this.scrollBuyBoxIntoPlace(target);

      // Un parpadeo corto para que se vea A DONDE lo mandamos. Sin esto el
      // usuario aterriza y no sabe que tiene que hacer.
      // Va por CLASE, no por estilo inline: el aro duro de 3px se veia como un
      // recuadro azul cuadrado encima de la caja. Ahora es un halo suave que
      // entra y sale, y respeta prefers-reduced-motion.
      target.classList.remove('sticky-atc-flash');
      void target.offsetWidth;              // reinicia la animacion si vuelven a darle
      target.classList.add('sticky-atc-flash');
      setTimeout(() => { target.classList.remove('sticky-atc-flash'); }, 1300);
    }

    /**
     * La caja de compra. El selector es editable desde el editor; la lista de
     * abajo son respaldos por si el tema de destino la nombra de otra forma.
     * Primero la ELECCION (escalera de paquetes / variantes) y luego el boton:
     * si aterrizas en el boton, la escalera te queda arriba, fuera de pantalla,
     * y el cliente sigue sin ver que tenia que escoger.
     */
    findBuyBox() {
      const candidates = [
        this.element.dataset.scrollTarget,
        'ms-oferta-block',
        'variant-picker',
        '.buy-buttons-block',
        'product-form-component',
        '.product-form-buttons',
        'form[data-type="add-to-cart-form"]',
        '.product-details'
      ].filter(Boolean);

      for (const selector of candidates) {
        try {
          const found = document.querySelector(selector);
          if (found) return found;
        } catch (error) {
          // selector escrito a mano en el editor: no tirar la pagina
        }
      }
      return null;
    }

    /* ─────────────────────────────────────────────────────────────────────
       MODO ESPEJO DE LA CAJA DE COMPRA

       El modo 'scroll' nacio por una razon buena: el precio depende de una
       eleccion (paquete 1/3/6 + suscripcion), y agregar a ciegas metia al
       carrito lo que estuviera marcado. Pero el remedio dejaba un boton que
       decia "Agregar al carrito" y no agregaba: habia que tocarlo DOS veces
       y en medio no pasaba nada visible.

       El espejo resuelve las dos cosas de una: la barra LEE la eleccion viva
       de la caja y la escribe en su propio rotulo ("Suscribirme · 3 frascos ·
       $1,618.20"). Con eso un solo toque puede agregar sin que nadie compre a
       ciegas, porque el boton dice exactamente que va a meter al carrito y a
       que precio. El toque se reenvia al boton real de la caja, que es el que
       sabe de planes, complementos y producto acompanante.

       El estado de la caja vive en el DOM a proposito (data-mode en el
       contenedor, is-on en la tarjeta, texto en [data-ms-total]) porque el
       tema la repinta con morph. Por eso aqui se observa el DOM: es la unica
       fuente fiel, no hay evento propio que escuchar.
       ───────────────────────────────────────────────────────────────────── */
    setupBuyBoxMirror() {
      if (this.element.dataset.buttonAction !== 'scroll') return;

      const box = document.querySelector('ms-oferta-block');
      if (!box || !box.querySelector('[data-ms-cta]')) return;

      this.buyBoxMirror = box;
      this.element.dataset.buyBoxMirror = 'true';
      this.updateMirrorLabel();

      // Debounce con setTimeout y NO con requestAnimationFrame: rAF se congela
      // mientras la pestana esta en segundo plano, y ahi el rotulo se quedaria
      // colgado mostrando el paquete anterior.
      let pendiente = null;
      const observer = new MutationObserver(() => {
        if (pendiente) return;                     // un repintado, un rotulo
        pendiente = setTimeout(() => {
          pendiente = null;
          this.updateMirrorLabel();
        }, 40);
      });
      observer.observe(box, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'data-mode', 'disabled']
      });
      this.observers.push(observer);
    }

    updateMirrorLabel() {
      // Si el tema repinto la seccion con morph y cambio el nodo, volvemos a
      // buscarlo: si no, el espejo se queda hablando de un DOM que ya no esta.
      if (this.buyBoxMirror && !document.contains(this.buyBoxMirror)) {
        this.buyBoxMirror = document.querySelector('ms-oferta-block');
      }
      const box = this.buyBoxMirror;
      const stickyButton = this.element && this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!box || !stickyButton) return;

      const label = stickyButton.querySelector('.add-to-cart-text__content');
      if (!label) return;

      // El rotulo dice lo que el toque VA A HACER, no lo que nos gustaria que
      // hiciera. Con la caja fuera de pantalla el boton viaja hasta ella; con
      // la caja enfrente, agrega. Decir "Agregar al carrito" en el primer caso
      // era justo el enredo original.
      const enPantalla = this.isBuyBoxInView(box);
      const partes = [];

      if (enPantalla) {
        // El verbo carga el modo: que la suscripcion se lea ANTES de tocar.
        partes.push(box.dataset.mode === 'sub' ? 'Suscribirme' : 'Agregar');

        const tier = box.querySelector('[data-ms-tier].is-on') || box.querySelector('[data-ms-tier]');
        const nombre = tier && tier.querySelector('.ms-oferta__tiername');
        if (nombre) {
          // El nombre trae dentro la pildora "Ahorras 40%". Se clona y se le
          // quita, en vez de recortar el texto a mano.
          const limpio = nombre.cloneNode(true);
          limpio.querySelectorAll('.ms-oferta__pill').forEach((pill) => pill.remove());
          const texto = limpio.textContent.replace(/\s+/g, ' ').trim();
          if (texto) partes.push(texto);
        }
      } else {
        partes.push('Ver mi paquete');
      }

      const total = box.querySelector('[data-ms-total]');
      const precio = total && total.textContent.replace(/\s+/g, ' ').trim();
      if (precio) partes.push(precio);

      const nuevo = partes.join(' · ');
      if (label.textContent.trim() !== nuevo) label.textContent = nuevo;

      const boxButton = box.querySelector('[data-ms-cta]');
      stickyButton.disabled = !boxButton || boxButton.disabled;
    }

    /**
     * Un toque = agregar. Mientras la caja responde, la barra muestra sus
     * puntos de carga y despues la palomita: ese era el "no sabes si esta
     * funcionando". Un segundo toque nervioso se ignora en vez de duplicar
     * la linea del carrito.
     */
    addFromBuyBoxMirror() {
      const box = this.buyBoxMirror;
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      const boxButton = box && box.querySelector('[data-ms-cta]');
      if (!boxButton || boxButton.disabled) return;
      if (!stickyButton || stickyButton.disabled || stickyButton.classList.contains('loading')) return;

      stickyButton.classList.add('loading');
      stickyButton.setAttribute('aria-busy', 'true');

      const terminar = (exito) => {
        if (!this.mirrorPending) return;
        this.mirrorPending = false;
        clearTimeout(this.mirrorTimeout);
        document.removeEventListener('cart:update', alAgregar);
        document.removeEventListener('cart:error', alFallar);
        stickyButton.classList.remove('loading');
        stickyButton.removeAttribute('aria-busy');
        if (exito) {
          stickyButton.dataset.added = 'true';
          setTimeout(() => stickyButton.removeAttribute('data-added'), 1600);
        }
        this.updateMirrorLabel();
      };
      const alAgregar = () => terminar(true);
      const alFallar = () => terminar(false);

      this.mirrorPending = true;
      document.addEventListener('cart:update', alAgregar);
      document.addEventListener('cart:error', alFallar);
      // Red de seguridad: si el evento nunca llega (una app que lo traga, la
      // red caida), la barra no se queda cargando para siempre.
      this.mirrorTimeout = setTimeout(() => terminar(false), 6000);

      boxButton.click();
    }

    /** El boton de VERDAD de la caja, el que si agrega al carrito. */
    findBuyBoxButton(box) {
      const scope = box || document;
      return (
        scope.querySelector('[data-ms-cta]') ||
        scope.querySelector('.add-to-cart-button') ||
        scope.querySelector('button[name="add"]') ||
        scope.querySelector('button[type="submit"]') ||
        this.mainAddToCartButton
      );
    }

    /**
     * Cuanto tapan el encabezado pegajoso de arriba y esta misma barra de
     * abajo. Se mide en vivo: cambia entre movil y escritorio, y con el
     * anuncio del header puesto o quitado.
     */
    stickyInsets() {
      let top = 0;
      const headerParts = document.querySelectorAll(
        '.shopify-section-group-header-group, .header-section, header-component'
      );
      headerParts.forEach((part) => {
        const position = getComputedStyle(part).position;
        if (position !== 'sticky' && position !== 'fixed') return;
        // Un hijo pegajoso dentro de un padre ya contado no suma dos veces.
        for (const other of headerParts) {
          if (other !== part && other.contains(part)) {
            const otherPosition = getComputedStyle(other).position;
            if (otherPosition === 'sticky' || otherPosition === 'fixed') return;
          }
        }
        top += part.getBoundingClientRect().height;
      });

      let bottom = 0;
      if (this.element && !this.element.classList.contains('sticky-add-to-cart--top')) {
        bottom = this.element.getBoundingClientRect().height || 0;
      }

      return { top: Math.round(top), bottom: Math.round(bottom) };
    }

    /**
     * "En pantalla" = o su boton esta completo en la zona libre, o se ve al
     * menos la mitad de lo que cabe de la caja. Con eso el cliente ya tiene
     * enfrente lo que eligio, asi que el clic puede agregar sin adivinar.
     */
    isBuyBoxInView(box) {
      if (!box) return false;
      const rect = box.getBoundingClientRect();
      const inset = this.stickyInsets();
      const zoneTop = inset.top;
      const zoneBottom = window.innerHeight - inset.bottom;
      if (zoneBottom <= zoneTop) return false;

      const button = this.findBuyBoxButton(box);
      if (button) {
        const b = button.getBoundingClientRect();
        if (b.height > 0 && b.top >= zoneTop && b.bottom <= zoneBottom) return true;
      }

      const visible = Math.min(rect.bottom, zoneBottom) - Math.max(rect.top, zoneTop);
      if (visible <= 0) return false;
      return visible >= Math.min(rect.height, zoneBottom - zoneTop) * 0.5;
    }

    triggerBuyBoxAddToCart(box) {
      const button = this.findBuyBoxButton(box);
      if (!button || button.disabled) return;
      button.click();
    }

    /**
     * Calcula el destino a mano en vez de usar scrollIntoView.
     *
     * scrollIntoView({block:'start'}) mandaba el borde de arriba de la caja al
     * pixel 0, donde el encabezado pegajoso se lo come. Y el destino se
     * calculaba UNA vez: mientras el scroll viajaba, las imagenes de arriba
     * terminaban de cargar, movian el layout y aterrizabas a media caja.
     *
     * Corregir eso a base de scrollTo repetidos fue peor: el tema trae
     * `scroll-behavior: smooth` GLOBAL en base.css, asi que cada llamada
     * REINICIA la animacion nativa desde donde va. El resultado se arrastraba
     * y se sentia trabado. Por eso aqui apagamos el smooth del CSS un momento
     * y animamos nosotros, recalculando el destino en CADA cuadro: si el
     * layout se mueve, la animacion lo absorbe sin cortarse.
     */
    scrollBuyBoxIntoPlace(target) {
      const destino = () => {
        const inset = this.stickyInsets();
        const rect = target.getBoundingClientRect();
        const pageTop = rect.top + window.scrollY;
        // La barra se esconde al viajar (ver ocultarDuranteViaje), asi que su
        // alto NO se descuenta: si lo descontaramos, el aterrizaje dejaria un
        // hueco de 64px donde ya no hay nada.
        const zoneTop = inset.top + 8;
        const zoneBottom = window.innerHeight - 12;
        const zoneHeight = Math.max(160, zoneBottom - zoneTop);

        let y;
        if (rect.height <= zoneHeight) {
          // Cabe entera: centrada en la zona libre.
          y = pageTop - zoneTop - (zoneHeight - rect.height) / 2;
        } else {
          // No cabe. Primero anclamos la ELECCION (la escalera de paquetes)
          // justo debajo del encabezado: es lo que hay que ver para elegir.
          const eleccion = this.findBuyBoxChoice(target);
          const anclaTop = eleccion.getBoundingClientRect().top + window.scrollY;
          y = anclaTop - zoneTop;

          // Y despues bajamos lo MINIMO necesario para que el boton de la caja
          // tambien entre. Que se vea el boton es lo que hace que la barra
          // pegajosa se esconda sola: sin eso queda flotando y parece que el
          // scroll no llego. Se empuja como mucho hasta meter la eleccion bajo
          // el encabezado; en pantallas muy bajas gana la eleccion y la barra
          // se queda (ahi el toque agrega, no viaja).
          const boton = this.findBuyBoxButton(target);
          if (boton) {
            const botonBottom = boton.getBoundingClientRect().bottom + window.scrollY;
            const empujeNecesario = botonBottom - zoneBottom - y;
            if (empujeNecesario > 0) y += Math.min(empujeNecesario, zoneTop);
          }
        }

        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        return Math.round(Math.min(Math.max(y, 0), maxScroll));
      };

      this.stopBuyBoxSettle();

      // La barra se retira EN CUANTO tocas, no al final: es el acuse de recibo
      // ("ya voy") y ademas deja de tapar el boton de la caja al aterrizar.
      // Mientras viaja, updateVisibility no la vuelve a meter (viajando=true),
      // que si no reaparecia a media animacion y se veia suelta.
      this.viajando = true;
      this.element.classList.remove('sticky-add-to-cart--visible');

      const raiz = document.documentElement;
      const smoothPrevio = raiz.style.scrollBehavior;
      raiz.style.scrollBehavior = 'auto';
      this.buyBoxRestoreSmooth = () => { raiz.style.scrollBehavior = smoothPrevio; };

      // Si el cliente toma el control, soltamos el scroll al instante.
      const cancelar = () => this.stopBuyBoxSettle();
      this.buyBoxSettleCancel = cancelar;
      ['wheel', 'touchstart', 'keydown'].forEach((evt) => {
        window.addEventListener(evt, cancelar, { passive: true, once: true });
      });

      const reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const inicio = window.scrollY;
      const duracion = reduceMotion ? 0 : 420;
      const t0 = performance.now();

      const paso = (ahora) => {
        this.buyBoxFrame = null;
        if (this.destroyed || !this.buyBoxSettleCancel) return this.stopBuyBoxSettle();
        const t = duracion ? Math.min(1, (ahora - t0) / duracion) : 1;
        const suave = 1 - Math.pow(1 - t, 3);                 // easeOutCubic
        window.scrollTo(0, Math.round(inicio + (destino() - inicio) * suave));
        if (t < 1) {
          this.buyBoxFrame = requestAnimationFrame(paso);
        } else {
          this.stopBuyBoxSettle();
          // Al aterrizar decidimos de nuevo: si el boton de la caja quedo a la
          // vista, la barra se queda guardada (llegaste); si no cupo, vuelve
          // ya con el rotulo de agregar.
          this.updateVisibility();
        }
      };
      this.buyBoxFrame = requestAnimationFrame(paso);
    }

    /**
     * El trozo de la caja donde se ELIGE (la escalera de paquetes). Es el
     * ancla del aterrizaje: si el cliente cae mas abajo, no ve que tenia algo
     * que escoger.
     */
    findBuyBoxChoice(box) {
      return (
        box.querySelector('.ms-oferta__tiers') ||
        box.querySelector('variant-picker') ||
        box.querySelector('.ms-oferta__modes') ||
        box
      );
    }

    stopBuyBoxSettle() {
      this.viajando = false;
      if (this.buyBoxFrame) {
        cancelAnimationFrame(this.buyBoxFrame);
        this.buyBoxFrame = null;
      }
      if (this.buyBoxRestoreSmooth) {
        this.buyBoxRestoreSmooth();
        this.buyBoxRestoreSmooth = null;
      }
      if (this.buyBoxSettleCancel) {
        ['wheel', 'touchstart', 'keydown'].forEach((evt) => {
          window.removeEventListener(evt, this.buyBoxSettleCancel);
        });
        this.buyBoxSettleCancel = null;
      }
    }

    triggerMainAddToCart() {
      if (!this.mainAddToCartButton) {
        console.warn('Main add to cart button not found');
        return;
      }

      // Check if the main button is disabled
      if (this.mainAddToCartButton.disabled) {
        return;
      }

      // Also check if the sticky button itself is disabled
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (stickyButton && stickyButton.disabled) {
        return;
      }

      if (this.hasQuantityBreaksWithDiscount()) {
        stickyButton.classList.add('loading');
      }

      // Trigger the main add to cart button click
      this.mainAddToCartButton.click();
    }

    hasQuantityBreaksWithDiscount() {
      const quantityBreaksEl = document.querySelector('[data-quantity-breaks-component]');
      const activeCard = quantityBreaksEl?.querySelector('.quantity-breaks__card--active');
      return !!activeCard?.dataset?.discountCode?.trim?.();
    }

    setupButtonStateSync() {
      // Sync the sticky button state with the main button state
      this.syncButtonState();
      
      // Listen for variant changes to update button state
      document.addEventListener('variant:update', (event) => {
        this.syncButtonState();
      });
      
      // Listen for variant selected events
      document.addEventListener('variant:selected', (event) => {
        this.syncButtonState();
      });
      
      // Also listen for form changes
      document.addEventListener('change', (event) => {
        if (event.target.name === 'id' && event.target.closest('form[data-type="add-to-cart-form"]')) {
          this.syncButtonState();
        }
      });
      
      // Add a small delay to ensure DOM is fully rendered
      setTimeout(() => {
        this.syncButtonState();
      }, 100);
      
      // Setup animation sync
      this.setupAnimationSync();
    }

    syncButtonState() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;

      // En modo "subir a la caja" el boton pegajoso NO es un espejo del boton
      // principal: tiene su propio rotulo y nunca se desactiva, porque subir a
      // la caja sigue teniendo sentido aunque la variante marcada este agotada.
      const scrollMode = this.element.dataset.buttonAction === 'scroll';

      if (this.mainAddToCartButton) {
        // Sync disabled state
        if (!scrollMode) stickyButton.disabled = this.mainAddToCartButton.disabled;

        // Sync button text
        const mainButtonText = this.getMainButtonText();
        const stickyButtonTextElement = stickyButton.querySelector('.add-to-cart-text__content');
        if (!scrollMode && stickyButtonTextElement && mainButtonText) {
          stickyButtonTextElement.textContent = mainButtonText;
        }
        
        // Sync icon visibility
        const stickyIcon = stickyButton.querySelector('.add-to-cart-icon');
        const mainIcon = this.mainAddToCartButton.querySelector('.add-to-cart-icon');
        
        if (stickyIcon) {
          if (mainIcon) {
            // Check if main icon is visible (not hidden by CSS or display:none)
            const mainIconComputedStyle = window.getComputedStyle(mainIcon);
            const isMainIconVisible = mainIconComputedStyle.display !== 'none' && 
                                     mainIconComputedStyle.visibility !== 'hidden' &&
                                     mainIconComputedStyle.opacity !== '0';
            
            // Show sticky icon if main icon is visible, hide if not
            stickyIcon.style.display = isMainIconVisible ? 'inline' : 'none';
          } else {
            // Que el boton principal NO traiga icono no es "no se": es la
            // respuesta. Corre con icon_mode: hide, y la barra fija tiene que
            // decir lo mismo que el boton al que acompana. Antes esta rama lo
            // PRENDIA mientras el boton estuviera habilitado, asi que la barra
            // inventaba un carrito que la ficha no tiene: el unico boton con
            // icono en toda la tienda. Cosechado de Bene (e0522c7, 27-ago).
            stickyIcon.style.display = 'none';
          }
        }
      } else {
        // Fallback: if main button not found, check if sticky button should be disabled based on initial state
        // The sticky button's initial disabled state should already be correct from Liquid
        // Just ensure the icon visibility matches the disabled state
        const stickyIcon = stickyButton.querySelector('.add-to-cart-icon');
        if (stickyIcon) {
          stickyIcon.style.display = stickyButton.disabled ? 'none' : 'inline';
        }
      }
      
      // Update quantity display
      this.updateButtonText();
    }
    
    setupQuantityUpdates() {
      // Listen for quantity selector update events
      // The event name is 'quantity-selector:update' (with hyphen)
      document.addEventListener('quantity-selector:update', (event) => {
        // Only respond to product page quantity selector updates, not cart drawer
        if (event.detail && event.detail.cartLine) return;
        
        this.currentQuantity = (event.detail && event.detail.quantity) ? parseInt(event.detail.quantity) : 1;
        this.updateButtonText();
      });
      
      // Also listen for ThemeEvents if available (for compatibility)
      if (window.ThemeEvents && window.ThemeEvents.quantitySelectorUpdate) {
        document.addEventListener(window.ThemeEvents.quantitySelectorUpdate, (event) => {
          if (event.detail && event.detail.cartLine) return;
          this.currentQuantity = (event.detail && event.detail.quantity) ? parseInt(event.detail.quantity) : 1;
          this.updateButtonText();
        });
      }
      
      // Also listen for direct input changes as a fallback
      const quantityInput = document.querySelector('quantity-selector-component input[type="number"], input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          this.currentQuantity = parseInt(quantityInput.value) || 1;
          this.updateButtonText();
        });
        quantityInput.addEventListener('input', () => {
          this.currentQuantity = parseInt(quantityInput.value) || 1;
          this.updateButtonText();
        });
      }
    }
    
    getInitialQuantity() {
      // Try to get initial quantity from quantity selector component
      const quantitySelector = document.querySelector('quantity-selector-component');
      if (quantitySelector) {
        const quantityInput = quantitySelector.querySelector('input[type="number"]');
        if (quantityInput) {
          return parseInt(quantityInput.value) || 1;
        }
        // Try to get value from component method if available
        if (quantitySelector.getValue && typeof quantitySelector.getValue === 'function') {
          const value = quantitySelector.getValue();
          if (value) return parseInt(value) || 1;
        }
      }
      
      // Try to get from form
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput) {
          return parseInt(quantityInput.value) || 1;
        }
      }
      
      return 1;
    }
    
    updateButtonText() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;
      
      const quantityDisplay = stickyButton.querySelector('[data-quantity-display], [ref="quantityDisplay"]');
      const quantityNumber = stickyButton.querySelector('[data-quantity-number], [ref="quantityNumber"]');
      
      if (!quantityDisplay || !quantityNumber) return;
      
      const available = !stickyButton.disabled;
      const quantity = this.currentQuantity || 1;
      
      // Update the quantity number
      quantityNumber.textContent = quantity.toString();
      
      // Show/hide the quantity display based on availability and quantity
      if (available && quantity > 1) {
        quantityDisplay.style.display = 'inline';
      } else {
        quantityDisplay.style.display = 'none';
      }
    }

    getMainButtonText() {
      if (!this.mainAddToCartButton) return null;
      
      const textElement = this.mainAddToCartButton.querySelector('.add-to-cart-text__content');
      return textElement ? textElement.textContent.trim() : null;
    }

    debugIconState() {
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      const stickyIcon = stickyButton?.querySelector('.add-to-cart-icon');
      const mainIcon = this.mainAddToCartButton?.querySelector('.add-to-cart-icon');
      
      console.log('Icon Debug:', {
        stickyButtonDisabled: stickyButton?.disabled,
        mainButtonDisabled: this.mainAddToCartButton?.disabled,
        stickyIconExists: !!stickyIcon,
        mainIconExists: !!mainIcon,
        stickyIconDisplay: stickyIcon?.style.display,
        mainIconDisplay: mainIcon?.style.display,
        mainIconComputedDisplay: mainIcon ? window.getComputedStyle(mainIcon).display : 'N/A'
      });
    }

    setupAnimationSync() {
      if (!this.mainAddToCartButton) return;
      // En modo "subir a la caja" el boton pegajoso no agrega nada, asi que
      // espejear el estado "agregado" del boton principal pondria una palomita
      // sobre un boton que dice "Elegir mi paquete".
      if (this.element.dataset.buttonAction === 'scroll') return;

      // Animation duration constant (same as in product-form.js)
      const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;
      const stickyButton = this.element.querySelector('[data-sticky-add-to-cart-button]');
      if (!stickyButton) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type !== 'attributes') return;
          const target = mutation.target;
          const stickyBtn = this.element.querySelector('[data-sticky-add-to-cart-button]');
          if (!stickyBtn) return;

          if (mutation.attributeName === 'data-added') {
            if (target.dataset.added === 'true') {
              if (stickyBtn.dataset.added !== 'true') {
                stickyBtn.dataset.added = 'true';
                setTimeout(() => stickyBtn.removeAttribute('data-added'), ADD_TO_CART_TEXT_ANIMATION_DURATION);
              }
            } else if (stickyBtn.dataset.added === 'true') {
              stickyBtn.removeAttribute('data-added');
            }
          } else if (mutation.attributeName === 'class' && this.hasQuantityBreaksWithDiscount()) {
            const mainHasLoading = this.mainAddToCartButton.classList.contains('loading');
            if (mainHasLoading) {
              stickyBtn.classList.add('loading');
            } else {
              stickyBtn.classList.remove('loading');
            }
          }
        });
      });

      observer.observe(this.mainAddToCartButton, {
        attributes: true,
        attributeFilter: ['data-added', 'class']
      });

      this.animationObserver = observer;
    }

    scrollToVariantSelector() {
      // Try to find variant selector in various possible locations
      const variantSelectors = [
        '.product-variants',
        '.variant-picker',
        '.product-options',
        '.product-form__options',
        '[data-testid="product-information-details"] .variant-picker',
        '.product-details .variant-picker',
        '.buy-buttons-block .variant-picker',
        'variant-picker'
      ];

      let targetElement = null;
      
      for (const selector of variantSelectors) {
        targetElement = document.querySelector(selector);
        if (targetElement) break;
      }

      if (targetElement) {
        // Scroll to the variant selector with smooth behavior
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        
        // Sin recuadro: el scroll ya dice a donde llegaste. El anillo de 2px pintaba
        // el navy institucional alrededor de TODO el selector y se leia como error
        // de interfaz, no como afordancia. (Leo, 20-ago: "me pone un recuadro azul".)
      } else {
        // Fallback: scroll to the main product form
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
          productForm.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }

    setupVisibilityClasses() {
      // Add classes for browsers that don't support :has() selector
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      // Check which elements are present and add appropriate classes
      if (!content.querySelector('.sticky-add-to-cart__image')) {
        content.classList.add('no-image');
      }
      if (!content.querySelector('.sticky-add-to-cart__title')) {
        content.classList.add('no-title');
      }
      if (!content.querySelector('.sticky-add-to-cart__variants')) {
        content.classList.add('no-variants');
      }
      if (!content.querySelector('.sticky-add-to-cart__price')) {
        content.classList.add('no-price');
      }
    }

    setupThemeEditorUpdates() {
      // Also listen for any changes to the section element (when section is updated in-place)
      const observer = new MutationObserver((mutations) => {
        if (this.destroyed) return;
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'data-section-settings' || 
               mutation.attributeName === 'data-shopify-editor-section')) {
            this.updateVisibilityFromSettings();
          }
        });
      });

      observer.observe(this.element, {
        attributes: true,
        attributeFilter: ['data-section-settings', 'data-shopify-editor-section']
      });
      this.observers.push(observer);

      // Poll for changes as a fallback
      const pollId = setInterval(() => {
        if (this.destroyed) return;
        this.updateVisibilityFromSettings();
      }, 1000);
      this.intervals.push(pollId);
    }

    updateVisibilityFromSettings() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      // Get current settings from the section
      const sectionSettings = this.getSectionSettings();
      
      // Update image visibility
      const imageElement = content.querySelector('.sticky-add-to-cart__image');
      if (imageElement) {
        // Remove existing mobile visibility classes
        imageElement.classList.remove('sticky-add-to-cart__image--hide-mobile');
        
        // Add mobile hide class if needed
        if (sectionSettings.show_image && !sectionSettings.show_image_mobile) {
          imageElement.classList.add('sticky-add-to-cart__image--hide-mobile');
        }
        
        // Overall image visibility
        imageElement.style.display = sectionSettings.show_image ? 'block' : 'none';
      }

      // Update title visibility
      const titleElement = content.querySelector('.sticky-add-to-cart__title');
      if (titleElement) {
        // Remove existing visibility classes
        titleElement.classList.remove('sticky-add-to-cart__title--hide-desktop', 'sticky-add-to-cart__title--hide-mobile');
        
        // Add appropriate classes based on settings
        if (!sectionSettings.show_title_desktop) {
          titleElement.classList.add('sticky-add-to-cart__title--hide-desktop');
        }
        if (!sectionSettings.show_title_mobile) {
          titleElement.classList.add('sticky-add-to-cart__title--hide-mobile');
        }
      }

      // Update variants visibility
      const variantsElement = content.querySelector('.sticky-add-to-cart__variants');
      if (variantsElement) {
        variantsElement.style.display = sectionSettings.show_variants ? 'block' : 'none';
        // Also update the variants display to refresh the change text
        if (sectionSettings.show_variants) {
          this.updateVariantsDisplay();
        }
      }

      // Update price visibility
      const priceElement = content.querySelector('.sticky-add-to-cart__price');
      if (priceElement) {
        priceElement.style.display = sectionSettings.show_price ? 'block' : 'none';
      }

      // Update image border radius
      this.updateImageBorderRadius(sectionSettings.image_border_radius);

      // Update layout classes
      this.updateLayoutClasses();
      
      // Update compact class
      this.updateCompactClass();
    }

    getSectionSettings() {
      // Try to get settings from various sources
      let settings = {};

      // Try to get from data attributes
      const settingsAttr = this.element.getAttribute('data-section-settings');
      if (settingsAttr) {
        try {
          settings = JSON.parse(settingsAttr);
        } catch (e) {
          // Fallback to default settings
        }
      }

      // Try to get from Shopify section data
      if (window.Shopify && window.Shopify.sections && this.element.dataset.sectionId) {
        const sectionData = window.Shopify.sections[this.element.dataset.sectionId];
        if (sectionData && sectionData.settings) {
          settings = { ...settings, ...sectionData.settings };
        }
      }

      // Default values
      return {
        show_image: settings.show_image !== false,
        show_image_mobile: settings.show_image_mobile !== false,
        show_title_desktop: settings.show_title_desktop !== false,
        show_title_mobile: settings.show_title_mobile !== false,
        show_variants: settings.show_variants !== false,
        show_price: settings.show_price !== false,
        show_on_desktop: settings.show_on_desktop !== false,
        show_on_mobile: settings.show_on_mobile !== false,
        show_at_top: settings.show_at_top || false,
        mobile_only_button: settings.mobile_only_button || false,
        mobile_no_padding: settings.mobile_no_padding || false,
        image_border_radius: settings.image_border_radius || 4,
        change_variant_text: settings.change_variant_text || 'Change',
        change_variant_link_enabled: settings.change_variant_link_enabled !== false,
        change_variant_link_style: settings.change_variant_link_style || (settings.change_variant_use_svg ? 'icon' : 'text'),
        compact: settings.compact || false,
        ...settings
      };
    }

    getChangeVariantText() {
      const settings = this.getSectionSettings();
      return settings.change_variant_text || 'Change';
    }

    updateLayoutClasses() {
      const content = this.element.querySelector('.sticky-add-to-cart__content');
      if (!content) return;

      const settings = this.getSectionSettings();

      // Update classes based on current visibility
      // For no-image class, consider both show_image and show_image_mobile
      // The CSS will handle the actual hiding, but we need to track if image should be considered "not present" for layout purposes
      const isMobile = window.innerWidth < 750;
      const imageVisibleOnCurrentDevice = settings.show_image && (isMobile ? settings.show_image_mobile : true);
      content.classList.toggle('no-image', !imageVisibleOnCurrentDevice);
      content.classList.toggle('no-title', !settings.show_title_desktop && !settings.show_title_mobile);
      content.classList.toggle('no-variants', !settings.show_variants);
      content.classList.toggle('no-price', !settings.show_price);
      
      // Add class for when title mobile is hidden (for fallback CSS)
      content.classList.toggle('has-title-mobile-hidden', !settings.show_title_mobile);
      
      // Add class for when all elements are hidden (for fallback CSS)
      const allElementsHidden = !imageVisibleOnCurrentDevice && !settings.show_title_desktop && !settings.show_title_mobile && !settings.show_variants && !settings.show_price;
      content.classList.toggle('all-elements-hidden', allElementsHidden);

    // Note: Full width button styling is now handled by CSS using :has() selector

      // Update desktop/mobile visibility classes
      this.element.classList.toggle('sticky-add-to-cart--hide-desktop', !settings.show_on_desktop);
      this.element.classList.toggle('sticky-add-to-cart--hide-mobile', !settings.show_on_mobile);
      this.element.classList.toggle('sticky-add-to-cart--mobile-only-button', settings.mobile_only_button);
      this.element.classList.toggle('sticky-add-to-cart--mobile-no-padding', settings.mobile_no_padding);
    }

    updateCompactClass() {
      const settings = this.getSectionSettings();
      
      // Toggle compact class based on setting
      this.element.classList.toggle('atc-compact', settings.compact);
    }

    updateImageBorderRadius(borderRadius) {
      const imageContainer = this.element.querySelector('.sticky-add-to-cart__image');
      const imageElement = this.element.querySelector('.sticky-add-to-cart__image img');
      
      if (imageContainer) {
        imageContainer.style.borderRadius = `${borderRadius || 4}px`;
      }
      
      if (imageElement) {
        imageElement.style.borderRadius = `${borderRadius || 4}px`;
      }
    }

    getChangeVariantSvg() {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" class="sticky-add-to-cart__change-icon" aria-hidden="true"><path d="M12 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12M9 15V12.5L17.75 3.75C18.4404 3.05964 19.5596 3.05964 20.25 3.75V3.75C20.9404 4.44036 20.9404 5.55964 20.25 6.25L15.5 11L11.5 15H9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    updateVariantsDisplay() {
      const variantsElement = this.element.querySelector('[data-sticky-variants]');
      if (!variantsElement) return;

      // Get selected variants from the page
      const selectedVariants = this.getSelectedVariants();
      const settings = this.getSectionSettings();
      
      if (selectedVariants.length > 0) {
        const variantsHTML = selectedVariants.map(variant => variant.value).join(' / ');
        const linkEnabled = settings.change_variant_link_enabled;
        const useIcon = settings.change_variant_link_style === 'icon';
        
        if (linkEnabled) {
          const changeContent = useIcon ? this.getChangeVariantSvg() : this.getChangeVariantText();
          const linkTitle = useIcon ? ` title="${(this.getChangeVariantText()).replace(/"/g, '&quot;')}"` : '';
          variantsElement.innerHTML = `${variantsHTML} <a href="#" class="sticky-add-to-cart__variant-link" data-scroll-to-variants${linkTitle}>${changeContent}</a>`;
        } else {
          variantsElement.innerHTML = variantsHTML;
        }
      } else {
        variantsElement.innerHTML = '';
      }

      // Also update the image
      this.updateImage();
    }

    updateImageFromVariant(variant) {
      const imageElement = this.element.querySelector('[data-sticky-image] img');
      if (!imageElement) return;

      if (variant && variant.featured_media) {
        const section = document.querySelector('[data-sticky-add-to-cart]');
        const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
        
        let dimensions;
        if (aspectRatio === 'adaptive') {
          dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
        } else {
          dimensions = this.getThumbnailDimensions();
        }
        
        const imageUrl = this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height);
        if (imageUrl) {
          imageElement.src = imageUrl;
          imageElement.alt = variant.featured_media.alt || `Variant ${variant.title} image`;
          imageElement.setAttribute('data-variant-image', variant.id || '');
          imageElement.removeAttribute('data-fallback-image');
          return;
        }
      }

      // Fallback to regular updateImage method
      this.updateImage();
    }

    updateImage() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const imageElement = this.element.querySelector('[data-sticky-image] img');
      if (!imageElement) return;

      // Try to get the selected variant image first
      const selectedVariantImage = this.getSelectedVariantImage();
      
      if (selectedVariantImage) {
        imageElement.src = selectedVariantImage.url;
        imageElement.alt = selectedVariantImage.alt || 'Imagen de la variante elegida';
        imageElement.setAttribute('data-variant-image', selectedVariantImage.variantId || '');
        imageElement.removeAttribute('data-fallback-image');
      } else {
        // Fallback to featured image
        const featuredImage = this.getFeaturedImage();
        if (featuredImage) {
          imageElement.src = featuredImage.url;
          imageElement.alt = featuredImage.alt || 'Imagen principal del producto';
          imageElement.setAttribute('data-fallback-image', 'true');
          imageElement.removeAttribute('data-variant-image');
        }
      }
    }

    getSelectedVariantImage() {
      // First try to get the currently selected variant from the form
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      
      if (form) {
        const variantIdInput = form.querySelector('input[name="id"]');
        
        if (variantIdInput && variantIdInput.value) {
          const variantId = variantIdInput.value;
          
          // Try multiple sources for variant data
          let variantData = window.productVariants || window.product?.variants;
          
          // Try to get from form data
          if (!variantData && form.dataset.variants) {
            try {
              variantData = JSON.parse(form.dataset.variants);
            } catch (e) {
              // Could not parse form variant data
            }
          }
          
          // Try to get from product form component
          if (!variantData) {
            const productForm = document.querySelector('product-form-component');
            if (productForm && productForm.dataset.variants) {
              try {
                variantData = JSON.parse(productForm.dataset.variants);
              } catch (e) {
                // Could not parse product form variant data
              }
            }
          }
          
          if (variantData && Array.isArray(variantData)) {
            const variant = variantData.find(v => v.id == variantId);
            
            if (variant && variant.featured_media) {
              const section = document.querySelector('[data-sticky-add-to-cart]');
              const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
              
              let dimensions;
              if (aspectRatio === 'adaptive') {
                dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
              } else {
                dimensions = this.getThumbnailDimensions();
              }
              
              return {
                url: this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height),
                alt: variant.featured_media.alt || `Variant ${variant.title} image`,
                variantId: variantId
              };
            }
          }
        }
      }

      // Fallback: check variant pickers
      const variantPickers = document.querySelectorAll('variant-picker');
      
      for (const picker of variantPickers) {
        const selectedInput = picker.querySelector('input:checked, select option:checked, select');
        
        if (selectedInput) {
          const variantId = selectedInput.dataset.variantId;
          if (variantId) {
            // Try to get variant data
            const variantData = window.productVariants || window.product?.variants;
            if (variantData) {
              const variant = variantData.find(v => v.id == variantId);
              if (variant && variant.featured_media) {
                const section = document.querySelector('[data-sticky-add-to-cart]');
                const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
                
                let dimensions;
                if (aspectRatio === 'adaptive') {
                  dimensions = this.getAdaptiveImageDimensions(variant.featured_media);
                } else {
                  dimensions = this.getThumbnailDimensions();
                }
                
                return {
                  url: this.getImageUrl(variant.featured_media, dimensions.width, dimensions.height),
                  alt: variant.featured_media.alt || `Variant ${variant.title} image`,
                  variantId: variantId
                };
              }
            }
          }
        }
      }

      // Additional fallback: check for any selected variant options and try to find the corresponding variant
      const selectedOptions = this.getSelectedVariants();
      if (selectedOptions.length > 0) {
        const variantData = window.productVariants || window.product?.variants;
        if (variantData) {
          // Try to find a variant that matches the selected options
          const matchingVariant = variantData.find(variant => {
            return selectedOptions.every(option => {
              const optionName = option.name.toLowerCase();
              const optionValue = option.value.toLowerCase();
              
              // Check if this variant has the selected option
              if (optionName.includes('color') && variant.option1 && variant.option1.toLowerCase() === optionValue) return true;
              if (optionName.includes('size') && variant.option2 && variant.option2.toLowerCase() === optionValue) return true;
              if (optionName.includes('style') && variant.option3 && variant.option3.toLowerCase() === optionValue) return true;
              
              return false;
            });
          });
          
          if (matchingVariant && matchingVariant.featured_media) {
            const section = document.querySelector('[data-sticky-add-to-cart]');
            const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
            
            let dimensions;
            if (aspectRatio === 'adaptive') {
              dimensions = this.getAdaptiveImageDimensions(matchingVariant.featured_media);
            } else {
              dimensions = this.getThumbnailDimensions();
            }
            
            return {
              url: this.getImageUrl(matchingVariant.featured_media, dimensions.width, dimensions.height),
              alt: matchingVariant.featured_media.alt || `Variant ${matchingVariant.title} image`,
              variantId: matchingVariant.id
            };
          }
        }
      }

      // Additional fallback: try to get image from main product display
      const mainImage = this.getCurrentMainImage();
      if (mainImage) {
        return mainImage;
      }

      return null;
    }

    getCurrentMainImage() {
      // Try to get the currently displayed image from the main product page
      const mainImageSelectors = [
        '.product-media img[data-variant-image]',
        '.media-gallery img[data-variant-image]',
        '.product-images img[data-variant-image]',
        '.product-media img:not([data-fallback-image])',
        '.media-gallery img:not([data-fallback-image])',
        '.product-images img:not([data-fallback-image])'
      ];

      for (const selector of mainImageSelectors) {
        const img = document.querySelector(selector);
        if (img && img.src) {
          return {
            url: img.src,
            alt: img.alt || 'Imagen del producto',
            variantId: img.dataset.variantImage || ''
          };
        }
      }

      return null;
    }

    getFeaturedImage() {
      // Get the product's featured image
      const productData = window.product || this.getProductFromPage();
      if (productData && productData.featured_media) {
        const section = document.querySelector('[data-sticky-add-to-cart]');
        const aspectRatio = section?.dataset.thumbnailAspectRatio || 'square';
        
        let dimensions;
        if (aspectRatio === 'adaptive') {
          dimensions = this.getAdaptiveImageDimensions(productData.featured_media);
        } else {
          dimensions = this.getThumbnailDimensions();
        }
        
        return {
          url: this.getImageUrl(productData.featured_media, dimensions.width, dimensions.height),
          alt: productData.featured_media.alt || 'Imagen principal del producto'
        };
      }

      return null;
    }

    getProductFromPage() {
      // Try to extract product data from the page
      const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (productForm && productForm.dataset.product) {
        try {
          return JSON.parse(productForm.dataset.product);
        } catch (e) {
          // Could not parse product data
        }
      }

      return null;
    }

    getImageUrl(media, width, height) {
      if (!media) return null;
      
      let imageUrl = null;
      
      // Handle different media types
      if (media.preview_image) {
        // Generate image URL with Shopify's image transformation
        const baseUrl = media.preview_image.src || media.preview_image;
        
        if (baseUrl) {
          // Use Shopify's image transformation API
          const params = new URLSearchParams({
            width: width.toString(),
            height: height.toString(),
            crop: 'center'
          });
          imageUrl = `${baseUrl}?${params.toString()}`;
        }
      } else if (media.src) {
        imageUrl = media.src;
      } else if (typeof media === 'string') {
        imageUrl = media;
      } else if (media.url) {
        imageUrl = media.url;
      }
      
      return imageUrl;
    }

    getThumbnailDimensions() {
      // Get thumbnail dimensions from the section settings
      const section = document.querySelector('[data-sticky-add-to-cart]');
      if (!section) return { width: 40, height: 40 };
      
      const size = parseInt(section.dataset.thumbnailSize) || 40;
      const aspectRatio = section.dataset.thumbnailAspectRatio || 'square';
      
      let width, height;
      switch (aspectRatio) {
        case 'portrait':
          width = size;
          height = Math.round(size * 1.33);
          break;
        case 'landscape':
          width = Math.round(size * 1.33);
          height = size;
          break;
        case 'wide':
          width = Math.round(size * 1.78);
          height = size;
          break;
        case 'adaptive':
          // For adaptive mode, we use a square container but let the image maintain its aspect ratio
          width = size;
          height = size;
          break;
        default: // square
          width = size;
          height = size;
      }
      
      return { width, height };
    }

    getAdaptiveImageDimensions(media) {
      // For adaptive mode, try to get the original image dimensions
      if (!media) return this.getThumbnailDimensions();
      
      const section = document.querySelector('[data-sticky-add-to-cart]');
      const maxSize = parseInt(section?.dataset.thumbnailSize) || 40;
      
      // Try to get original dimensions from the media object
      let originalWidth = null;
      let originalHeight = null;
      
      if (media.preview_image) {
        originalWidth = media.preview_image.width;
        originalHeight = media.preview_image.height;
      } else if (media.width && media.height) {
        originalWidth = media.width;
        originalHeight = media.height;
      }
      
      if (originalWidth && originalHeight) {
        // Calculate dimensions that fit within the max size while maintaining aspect ratio
        const aspectRatio = originalWidth / originalHeight;
        
        let width, height;
        if (aspectRatio > 1) {
          // Landscape image
          width = maxSize;
          height = Math.round(maxSize / aspectRatio);
        } else {
          // Portrait or square image
          height = maxSize;
          width = Math.round(maxSize * aspectRatio);
        }
        
        return { width, height };
      }
      
      // Fallback to square if we can't determine dimensions
      return { width: maxSize, height: maxSize };
    }

    getSelectedVariants() {
      const variants = [];
      const addedOptions = new Set(); // Track added options to prevent duplicates
      
      // Find all variant pickers on the page
      const variantPickers = document.querySelectorAll('variant-picker');
      
      variantPickers.forEach(picker => {
        // Look for all checked inputs within this picker
        const checkedInputs = picker.querySelectorAll('input:checked, select option:checked');
        
        checkedInputs.forEach(selectedInput => {
          const optionName = picker.dataset.optionName || this.getOptionNameFromInput(selectedInput);
          const optionValue = selectedInput.value || selectedInput.textContent;
          
          if (optionName && optionValue) {
            const optionKey = `${optionName}:${optionValue}`.toLowerCase();
            if (!addedOptions.has(optionKey)) {
              variants.push({
                name: optionName,
                value: optionValue
              });
              addedOptions.add(optionKey);
            }
          }
        });
      });

      // Also check for form inputs
      const formInputs = document.querySelectorAll('form[data-type="add-to-cart-form"] input[name^="options"]');
      formInputs.forEach(input => {
        if (input.checked || input.type === 'hidden') {
          const optionName = input.name.replace('options[', '').replace(']', '');
          const optionValue = input.value;
          
          if (optionName && optionValue) {
            const optionKey = `${optionName}:${optionValue}`.toLowerCase();
            if (!addedOptions.has(optionKey)) {
              variants.push({
                name: optionName,
                value: optionValue
              });
              addedOptions.add(optionKey);
            }
          }
        }
      });

      // Additional fallback: look for any selected variant options in the DOM
      const allCheckedInputs = document.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked, select option:checked');
      allCheckedInputs.forEach(input => {
        // Skip if we already processed this input. Tampoco se leen los selectores de
        // OTROS productos (tarjetas de «Más aromas», carrito): su valor es el id de la
        // variante y la barra imprimía «60 ML / 37575861207190 / …» (23-sep-2026).
        if (input.closest('variant-picker') || input.closest('product-card, ms-card-purchase, cart-upsell-component, cart-drawer-component') || (input.name && input.name.startsWith('options['))) {
          return;
        }
        
        const optionName = this.getOptionNameFromInput(input);
        const optionValue = input.value || input.textContent;
        
        if (optionName && optionValue && optionName !== 'Option') {
          const optionKey = `${optionName}:${optionValue}`.toLowerCase();
          if (!addedOptions.has(optionKey)) {
            variants.push({
              name: optionName,
              value: optionValue
            });
            addedOptions.add(optionKey);
          }
        }
      });

      return variants;
    }

    getOptionNameFromInput(input) {
      // Try to get option name from various sources
      const label = input.closest('label');
      if (label) {
        const labelText = label.textContent.trim();
        const colonIndex = labelText.indexOf(':');
        if (colonIndex > 0) {
          return labelText.substring(0, colonIndex).trim();
        }
      }

      // Try to get from parent element
      const parent = input.closest('[data-option-name]');
      if (parent) {
        return parent.dataset.optionName;
      }

      // Try to get from fieldset legend
      const fieldset = input.closest('fieldset');
      if (fieldset) {
        const legend = fieldset.querySelector('legend');
        if (legend) {
          return legend.textContent.trim();
        }
      }

      return 'Option';
    }

    updatePriceFromVariantId(variantId) {
      // Try multiple ways to get variant data
      let variantData = window.productVariants || window.product?.variants;
      
      // If not found, try to get from the product form
      if (!variantData) {
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
          variantData = JSON.parse(productForm.dataset.variants || '[]');
        }
      }

      // If still not found, try to get from the product information section
      if (!variantData) {
        const productInfo = document.querySelector('[data-testid="product-information-details"]');
        if (productInfo) {
          variantData = JSON.parse(productInfo.dataset.variants || '[]');
        }
      }

      if (!variantData) return;

      const variant = variantData.find(v => v.id == variantId);
      if (variant) {
        this.updatePrice(variant);
        this.updateVariantsDisplay();
      } else {
        this.updateVariantsDisplay();
      }
    }

    updatePriceFromVariantData(variantData) {
      if (variantData && variantData.variant) {
        this.updatePrice(variantData.variant);
      }
    }

    updatePriceFromForm(variantId) {
      // Find the variant data from the page
      const variantData = window.productVariants || window.product?.variants;
      if (!variantData) return;

      const variant = variantData.find(v => v.id == variantId);
      if (variant) {
        this.updatePrice(variant);
      }
    }

    updatePrice(variant) {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // Check if quantity breaks block is present and has an active card
      // If so, use price from quantity breaks instead of variant price (only if override is enabled in sticky-add-to-cart)
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (stickyOverrideEnabled) {
        const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
        if (quantityBreaksComponent) {
          const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
          if (activeCard) {
            // Defer so quantity-breaks.js has updated its prices first (same variant:update event)
            setTimeout(() => this.updatePriceFromQuantityBreaks(), 0);
            return;
          }
        }
      }

      if (variant) {
        // When override is disabled, copy from main price (server-rendered, correct currency/format)
        // Defer so product-price.js has updated the main price from variant response first
        setTimeout(() => this.copyPriceFromMain(), 0);
      } else {
        this.copyPriceFromMain();
      }
    }

    copyPriceFromMain() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement) return;

      // First check if quantity breaks price is available (only if override is enabled in sticky-add-to-cart)
      const stickyOverrideEnabled = this.element.dataset.overrideProductPrice === 'true';
      if (stickyOverrideEnabled) {
        const quantityBreaksComponent = document.querySelector('[data-quantity-breaks-component]');
        if (quantityBreaksComponent) {
          const activeCard = quantityBreaksComponent.querySelector('.quantity-breaks__card--active');
          if (activeCard) {
            this.updatePriceFromQuantityBreaks();
            return;
          }
        }
      }

      // Copy from main product price container (server-rendered, correct currency/format)
      // Main price is in product-information (or similar), not in this section
      const mainPriceContainer = document.querySelector('product-price [ref="priceContainer"]');
      if (mainPriceContainer) {
        const stickyPriceContainer = priceElement.querySelector('[ref="priceContainer"]') || priceElement;
        stickyPriceContainer.innerHTML = mainPriceContainer.innerHTML;
        // show_sale_badge: false — remove sale badge from sticky bar
        stickyPriceContainer.querySelector('.sale-badge')?.remove();
        this.updateVariantsDisplay();
        return;
      }

      // Fallback: try legacy selectors for single .price element
      const mainPriceSelectors = [
        '.product-details .price',
        '[data-testid="product-information-details"] .price',
        '.buy-buttons-block .price',
        'product-form-component .price'
      ];
      for (const selector of mainPriceSelectors) {
        const mainPrice = document.querySelector(selector);
        if (mainPrice) {
          priceElement.innerHTML = mainPrice.innerHTML;
          // show_sale_badge: false — remove sale badge from sticky bar
          priceElement.querySelector('.sale-badge')?.remove();
          this.updateVariantsDisplay();
          return;
        }
      }
    }

    setupPriceObserver() {
      // Watch for changes in the main price display
      const mainPriceSelectors = [
        '.product-details .price',
        '[data-testid="product-information-details"] .price',
        '.buy-buttons-block .price',
        'product-form-component .price'
      ];

      mainPriceSelectors.forEach(selector => {
        const mainPrice = document.querySelector(selector);
        if (mainPrice) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                this.copyPriceFromMain();
              }
            });
          });

          observer.observe(mainPrice, {
            childList: true,
            subtree: true,
            characterData: true
          });

        }
      });
    }

    updatePriceDisplay(priceData) {
      const priceElement = this.element.querySelector('[data-sticky-price]');
      if (!priceElement || !priceData) return;

      // Update with the provided price data
      priceElement.innerHTML = priceData.html || priceData;
    }

    formatPrice(variant) {
      if (!variant) return '';

      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const priceEl = this.element?.querySelector('[data-sticky-price]');
      const showSaleFirst = !priceEl || priceEl.dataset.showSalePriceFirst !== 'false';
      const fmt = (c) =>
        typeof Theme !== 'undefined' && Theme.formatPriceSplitHTML
          ? Theme.formatPriceSplitHTML(c, false, 'upsells')
          : this.formatMoney(c);

      const sale = `<span class="price">${fmt(price)}</span>`;
      if (compareAtPrice && compareAtPrice > price) {
        const cmp = `<span class="compare-at-price price--compare">${fmt(compareAtPrice)}</span>`;
        return showSaleFirst ? `${sale}${cmp}` : `${cmp}${sale}`;
      }
      return sale;
    }

    formatMoney(cents) {
      if (!this.element) return '';
      const amount = cents / 100;
      const moneyFormat = this.element.dataset.moneyFormat ||
        (typeof window.Theme !== 'undefined' && window.Theme.moneyFormat);
      const currency = this.element.dataset.currency ||
        (typeof window.Theme !== 'undefined' && window.Theme.currency) || 'USD';
      if (moneyFormat) {
        const formatted = amount.toFixed(2);
        const rounded = String(Math.round(amount));
        const withComma = amount.toFixed(2).replace('.', ',');
        let result = moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, formatted)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatted.replace('.', "'"))
          .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, rounded)
          .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, formatted);
        result = result.replace(/<[^>]+>/g, '').trim();
        // Sin «.00» cuando el importe es entero (mismo criterio que Theme.formatMoney).
        return cents % 100 === 0 ? result.replace(/([.,])00(?=\s|$|[^\d])/g, '') : result;
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    }

    updateVisibility() {
      if (this.destroyed || !this.element || !document.contains(this.element)) return;
      // Mientras la barra lleva al cliente a la caja se queda guardada: si
      // reapareciera a media animacion parpadearia y se veria suelta.
      if (this.viajando) return;
      // El rotulo depende de si la caja esta a la vista, asi que se recalcula
      // en el mismo latido del scroll que ya existe.
      if (this.buyBoxMirror) this.updateMirrorLabel();
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Get section settings to check if it's positioned at top
      const settings = this.getSectionSettings();
      const isAtTop = settings.show_at_top;
      
      // Check scroll position based on sticky cart position
      if (isAtTop) {
        // If positioned at top, hide when scrolled to top
        const isAtTopOfPage = scrollY <= 10; // 10px tolerance
        if (isAtTopOfPage) {
          this.element.classList.remove('sticky-add-to-cart--visible');
          return;
        }
        
        // If positioned at top, show when scrolled to bottom
        const isAtBottom = (scrollY + windowHeight) >= (documentHeight - 10); // 10px tolerance
        if (isAtBottom) {
          this.element.classList.add('sticky-add-to-cart--visible');
          return;
        }
      } else {
        // If positioned at bottom, hide when scrolled to bottom
        const isAtBottom = (scrollY + windowHeight) >= (documentHeight - 10); // 10px tolerance
        if (isAtBottom) {
          this.element.classList.remove('sticky-add-to-cart--visible');
          return;
        }
      }

      // «Aparece cuando…» (Bene Rev 5.26, 1-sep-2026 — cosechado al golden el
      // 21-sep, tres semanas tarde: Leo lo volvio a ver en la demo).
      // Antes la barra salia si el boton «no estaba completo en pantalla», y eso
      // incluye cuando TODAVIA NO LLEGA: en el telefono el boton queda bajo el
      // pliegue al abrir la ficha, asi que la barra salia desde arriba, encima
      // de la zona de compra.
      //  · boton   (default) → solo cuando el boton ya quedo ARRIBA del viewport
      //  · seccion → cuando termino toda la informacion del producto
      if (settings.show_after === 'seccion') {
        const info = this.mainAddToCartButton?.closest('.product-information')
          || document.querySelector('.product-information');
        if (info) {
          this.element.classList.toggle('sticky-add-to-cart--visible', info.getBoundingClientRect().bottom <= 0);
          return;
        }
      }
      if (this.mainAddToCartButton) {
        const mainRect = this.mainAddToCartButton.getBoundingClientRect();
        this.element.classList.toggle('sticky-add-to-cart--visible', mainRect.bottom < 0);
        return;
      }
      // Respaldo sin boton principal: se exige haber bajado al menos una
      // pantalla. Antes salia en el pixel 0 y tapaba el hero.
      this.element.classList.toggle('sticky-add-to-cart--visible', scrollY > windowHeight * 0.6);
    }

    setupScrollListener() {
      let ticking = false;
      
      const updateVisibility = () => {
        this.updateVisibility();
        ticking = false;
      };

      const requestTick = () => {
        if (!ticking) {
          requestAnimationFrame(updateVisibility);
          ticking = true;
        }
      };

      window.addEventListener('scroll', requestTick, { passive: true });
      
      // Also check on resize in case viewport changes
      window.addEventListener('resize', () => {
        requestTick();
        // Update layout classes on resize to handle mobile/desktop image visibility
        this.updateLayoutClasses();
      }, { passive: true });
      
      // Re-scan for main button periodically in case it loads dynamically
      const scanId = setInterval(() => {
        if (this.destroyed) return;
        const newMainButton = this.findMainAddToCartButton();
        if (newMainButton !== this.mainAddToCartButton) {
          // Clean up old animation observer
          if (this.animationObserver) {
            this.animationObserver.disconnect();
          }
          
          this.mainAddToCartButton = newMainButton;
          // Sync state when main button changes
          this.syncButtonState();
          // Re-setup animation sync for new button
          this.setupAnimationSync();
        }
      }, 2000);
      this.intervals.push(scanId);
    }
  }

  // Make StickyAddToCart available globally for morph callbacks
  window.StickyAddToCart = StickyAddToCart;

  function initStickyAddToCart() {
    if (window.stickyAddToCartInstance) {
      window.stickyAddToCartInstance.destroy();
    }
    window.stickyAddToCartInstance = new StickyAddToCart();
  }

  function isStickyAddToCartSection(target) {
    return target && target.querySelector && target.querySelector('[data-sticky-add-to-cart]');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStickyAddToCart());
  } else {
    initStickyAddToCart();
  }

  // Re-initialize when section is replaced in theme editor (e.g. after settings change)
  document.addEventListener('shopify:section:load', (event) => {
    if (isStickyAddToCartSection(event.target)) {
      initStickyAddToCart();
    }
  });
  document.addEventListener('shopify:theme:section:load', (event) => {
    if (isStickyAddToCartSection(event.target)) {
      initStickyAddToCart();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
